/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/img-redundant-alt */
import React, { useEffect, useContext, useState } from "react";
import { Link } from "react-router-dom";
import { useInView } from "react-intersection-observer";
import { useTranslation } from "react-i18next";
import Translate from "../../i18n/Translate";

import { I18nContext } from "../../context/I18nProvider";
import ObserverContext from "../../context/Observer";
import PollContext from "../../context/Poll";

import useScrollToTop from "../../hooks/useScrollToTop";
import useWindowWidth from "../../hooks/useWindowWidth";

import Selects from "../../components/Selects";
import SliderEvents from "./SliderEvents";
import ImagePopup from "../../components/Home/ImagePopup";
// import Polls from "./Polls";

import HeroImage from "../../assets/images/static/main__hero__image.png";
import api from "../../api/Api";

const Home = () => {
  const [data, setData] = useState({
    loading: false,
    data: null,
    error: null,
  });

  const [showPopup, setShowPopup] = useState(false);

  const { elementInview, setElementInview } = useContext(ObserverContext);
  const { voted, setVoted } = useContext(PollContext);

  const { ref, inView } = useInView({
    threshold: 0.5,
  });

  const { setActualComponent } = useContext(I18nContext);

  // const { language } = useContext(I18nContext)

  const { t } = useTranslation();

  const width = useWindowWidth();


  const homeData = data?.data?.data;
  const shouldShowPopup = homeData?.showPopup && homeData?.popupImage;

  // Scroll to top
  useScrollToTop();

  const getData = async () => {
    setData({
      ...data,
      loading: true,
      error: null,
    });

    try {
      const data = await api.home.getContent();
      setData({
        data,
        loading: false,
      });
    } catch (error) {
      setData({
        loading: false,
        error,
      });
      console.log("error");
    }
  };

  // Detectamos si el elemento está en el viewport
  useEffect(() => {
    // setElementInview(!inView);
    if (width > 992) {
      setElementInview(!inView);
    } else {
      setElementInview(true);
    }
  }, [inView, width]);

  // Seteamos el componente actual, para las traduccion de rutas
  useEffect(() => {
    setActualComponent("home");
  }, [setActualComponent]);

  // Detectamos si el usuario ya votó
  useEffect(() => {
    getData();
    const isUserVoted = localStorage.getItem("isUserVote");

    if (isUserVoted !== null) {
      setVoted({
        voted: true,
        ip: JSON.parse(isUserVoted).ip,
      });
    }
  }, []);

  useEffect(() => {
    if (shouldShowPopup) {
      setShowPopup(true);
    }
  }, [shouldShowPopup]);

  return (
    <>
      {/* Main */}
      <main className="main">
        <div className="main__image triangle right" style={{backgroundImage: `url("${homeData?.backRightImage}"`}}></div>

        <div className="main__image triangle left" style={{backgroundImage: `url("${homeData?.backLeftImage}"`}}></div>

        <div className="hero">
          <div className="hero__image">
            <img src={homeData?.frontImage} alt="Hero Image" />
          </div>

          <div className="hero__container">
            <h1 className="hero__title" ref={ref}>
              {homeData?.mainTitle}
            </h1>
            <h2 className="hero__subtitle">
              {homeData?.mainSubtitle}
            </h2>
            {data?.data && <Link to={data?.data.data.mainButtonLink}  className="callToAction" >
              {homeData?.mainButtonText}
            </Link> }
          </div>

          <div className="hero__selects">
            <Selects />
          </div>
        </div>

        <div className={elementInview ? "main__copy isVisible" : "main__copy"}>
          <h2 className="main__copy__title">
            {homeData?.secondaryTitle}
          </h2>
          <p>
            {homeData?.secondaryText}
          </p>

          {data?.data && <Link to={homeData?.secondaryButtonLink}>
            {homeData?.secondaryButtonText}
          </Link>}
        </div>
      </main>
      {/* End Main */}

      {/* Eventos */}
      <SliderEvents />
      {/* End Eventos */}

      {/* Encuesta */}
      {/* A futuro, agregar componente Polls aca */}
      {/*  End Encuesta */}

      {/* Image Popup */}
      {shouldShowPopup && (
        <ImagePopup
          isVisible={showPopup}
          onClose={() => setShowPopup(false)}
          imageUrl={homeData.popupImage}
          redirectUrl={homeData.popupLink}
        />
      )}

      {/* End Image Popup */}
    </>
  );
};

export default Home;
